var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/Dashboard"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "175px"
    },
    attrs: {
      "src": require("../../static/img/logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler sidebar-toggler d-md-down-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    staticStyle: {
      "margin-right": "1%"
    },
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "top": "5px"
    }
  }, [_c('div', {
    staticClass: "d-md-down-none",
    staticStyle: {
      "color": "#fff",
      "display": "inline-block"
    }
  }, [_vm._v("Welcome " + _vm._s(_vm.username) + " , ")]), _vm._v(" "), _c('div', {
    staticClass: "crnt_hub"
  }, [_vm._v(_vm._s(_vm.hubName) + " "), _c('span', [_vm._v(_vm._s(_vm.brookText))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "bottom": "5px"
    }
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })])]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.changehub
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v("Change Hub")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.changepasswordRoute
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Change Password")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout")])], 2)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749d281c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 499
// module chunks = 2